<template>
  <span>
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="{ color: strokeColor }"
    >
      <path
        d="M19.3053 6.61021C19.1195 6.39961 18.8909 6.23096 18.6349 6.11546C18.3789 5.99996 18.1012 5.94026 17.8203 5.94031H13.2003V4.62031C13.2003 3.7451 12.8526 2.90573 12.2338 2.28686C11.6149 1.66799 10.7755 1.32031 9.90031 1.32031C9.7777 1.32022 9.65748 1.3543 9.55315 1.4187C9.44881 1.48311 9.36448 1.57531 9.30961 1.68496L6.19276 7.92031H2.64031C2.29023 7.92031 1.95448 8.05938 1.70693 8.30693C1.45938 8.55448 1.32031 8.89023 1.32031 9.24031V16.5003C1.32031 16.8504 1.45938 17.1861 1.70693 17.4337C1.95448 17.6812 2.29023 17.8203 2.64031 17.8203H16.8303C17.3127 17.8205 17.7785 17.6445 18.1404 17.3255C18.5022 17.0065 18.7352 16.5664 18.7955 16.0878L19.7855 8.16781C19.8206 7.88898 19.7959 7.60588 19.7131 7.33731C19.6303 7.06875 19.4913 6.82089 19.3053 6.61021ZM2.64031 9.24031H5.94031V16.5003H2.64031V9.24031ZM18.4754 8.00281L17.4854 15.9228C17.4653 16.0823 17.3876 16.2291 17.267 16.3354C17.1464 16.4417 16.9911 16.5004 16.8303 16.5003H7.26031V8.73624L10.2889 2.67826C10.7378 2.7681 11.1416 3.0107 11.4318 3.36478C11.7219 3.71886 11.8804 4.16254 11.8803 4.62031V6.60031C11.8803 6.77536 11.9498 6.94323 12.0736 7.067C12.1974 7.19078 12.3653 7.26031 12.5403 7.26031H17.8203C17.914 7.26028 18.0066 7.28018 18.0919 7.31869C18.1773 7.35721 18.2535 7.41345 18.3155 7.48368C18.3774 7.55391 18.4237 7.63653 18.4513 7.72603C18.4789 7.81554 18.4871 7.90989 18.4754 8.00281Z"
        fill="currentColor"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'ThumbsUp',
  props: {
    strokeColor: {
      type: String,
      default: '#497D00',
    },
    size: {
      type: [Number, String],
      default: 18,
    },
  },
};
</script>
